<div class="pre-footer">
  <div class="footer-column">
    <h3>Beto Crypto</h3>
    <div class="biography" [innerHTML]="translations?.contact?.biography"></div>
  </div>

  <div class="footer-column">
    <h3>Empresa</h3>
    <p><a href="https://betocrypto.edugogo.ai/terminos-y-condiciones" target="_blank">Términos y condiciones</a></p>
    <p><a href="https://betocrypto.edugogo.ai/politica-de-privacidad" target="_blank">Política de privacidad</a></p>
  </div>

  <div class="footer-column">
    <h3>Síguenos</h3>
    <p><a href="https://instagram.com/Betocrypto" target="_blank"><ion-icon name="logo-instagram"></ion-icon> Instagram</a></p>
    <p><a href="https://tiktok.com/@betocrypto" target="_blank"><ion-icon name="logo-tiktok"></ion-icon> TikTok</a></p>
    <p><a href="https://www.facebook.com/people/Beto-Crypto/100078317803546/" target="_blank"><ion-icon name="logo-facebook"></ion-icon> Facebook</a></p>
    <p><a href="https://www.twitter.com/Betocryptos" target="_blank"><ion-icon name="logo-x"></ion-icon> X</a></p>
    <p><a href="https://www.youtube.com/@betocryptoo" target="_blank"><ion-icon name="logo-youtube"></ion-icon> YouTube</a></p>
  </div>

  <div class="footer-column">
    <h3>Contáctanos</h3>
    <p>Miami, Florida</p>
    <h4>Admisiones</h4>
    <p>
      <ion-icon name="mail-outline"></ion-icon>
      <a href="mailto:humberto&#64;betocryptos.com">humberto&#64;betocryptos.com</a>
    </p>
    <h4>Atención al estudiante</h4>
    <p>
      <ion-icon name="logo-whatsapp"></ion-icon>
      <a href="https://wa.me/17863409929" target="_blank">+1 786 340 9929</a>
    </p>
    <p>
      <ion-icon name="mail-outline"></ion-icon>
      <a href="mailto:humberto&#64;betocryptos.com">humberto&#64;betocryptos.com</a>
    </p>
  </div>
</div>
